var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinessInteligence(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M16.01 18.41a2.4 2.4 0 100-4.8 2.4 2.4 0 000 4.8z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M19.97 19.97c6.248-6.249 9.54-13.087 7.354-15.274C25.137 2.509 18.298 5.8 12.05 12.05c-6.248 6.248-9.54 13.086-7.354 15.273 2.187 2.187 9.025-1.105 15.274-7.354z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M27.324 27.323c2.186-2.187-1.106-9.025-7.354-15.273C13.72 5.8 6.883 2.509 4.696 4.696 2.51 6.883 5.802 13.72 12.05 19.969c6.248 6.249 13.087 9.541 15.274 7.354z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgBusinessInteligence;